import { makeStyles } from '@material-ui/core';
import { FormControl, FormLabel, FormGroup, FormControlLabel, FormHelperText, Radio } from '@material-ui/core';
import { getIn } from 'formik';
import React from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

interface IOption {
  label: string;
  value: string;
}

interface IProps extends FieldProps {
  label?: string;
  formStyle?: any;
  formControlStyle?: any;
  options: IOption[];
  row?: boolean;
}

const useStyles = makeStyles(() => ({
  formLabel: {
    fontSize: 15,
  },
  formControlLabel: {
    fontSize: 15,
  },
}));

export const ListRadioButtonFormField = ({ field, form, label, options, formStyle, formControlStyle, row }: IProps) => {
  const classes = useStyles();

  const errorText = getIn(form.errors, field.name);

  return (
    <FormControl fullWidth error={!!errorText}>
      <Hint inputName={field.name}>
        <FormLabel className={classes.formLabel}>{label}</FormLabel>
        <FormGroup row={row} style={formStyle}>
          {options.map((op) => {
            return (
              <FormControlLabel
                className={classes.formControlLabel}
                style={formControlStyle}
                key={op.value}
                control={
                  <Radio
                    checked={field.value === op.value}
                    onChange={(e) => form.setFieldValue(field.name, e.target.checked ? op.value : null)}
                    value={op.value}
                  />
                }
                label={op.label}
              />
            );
          })}
        </FormGroup>
      </Hint>
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};
